import { type UseMutationOptions, useMutation } from "@tanstack/react-query";
import { api } from "api";
import { useState } from "react";
import type { BulkRequestItem } from "api/requests";

type Options = UseMutationOptions<void, Error, BulkRequestItem[]>;

/**
 * Client hook to perform a Bulk Request.
 * @param options Options for the client call; provides callbacks for when the API call succeeds or fails.
 * @returns React Query mutation properties. 'data' is a "draft id", which is a number that changes with each submission.
 */
export function useBulkRequest(options?: Options) {
    const [draftId, setDraftId] = useState(0);

    const { isPending, mutateAsync } = useMutation({
        ...options,
        mutationFn: async (items: BulkRequestItem[]) => {
            await api.provider.bulkRequest(items);
            setDraftId((currDraftId) => currDraftId + 1);
        },
    });

    return { isPending, mutateAsync, draftId } as const;
}
